import React, { useState } from 'react'
import { Card, CardContent, Button } from '@wove/web-ui'
import { Lock, Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import useUserStore from '@src/state/user'
import { requestAccess } from '@wove/api'

const RequestAccess: React.FC = () => {
  const [requesting, setRequesting] = useState(false)
  const customer = useUserStore((state) => state.customer)
  const user = useUserStore((state) => state.user)

  const handleRequestAccess = async () => {
    setRequesting(true)

    try {
      const response = await requestAccess()

      if (response.success) {
        toast.success('Access requested successfully', {
          description: 'Our team will review your request and get back to you soon.',
        })
      } else {
        throw new Error('Failed to send request')
      }
    } catch (error) {
      console.error('Error requesting access:', error)
      toast.error('Failed to request access', {
        description: 'Please try again or contact support.',
      })
    } finally {
      setRequesting(false)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-[80vh] p-4">
      <Card className="max-w-md w-full">
        <CardContent className="text-center py-12 px-8">
          <div className="mb-6">
            <Lock className="mx-auto text-gray-400" size={64} />
          </div>

          <h2 className="text-2xl font-bold mb-4">Shipments Module Not Enabled</h2>

          <p className="text-gray-600 mb-8">
            The shipments module is not currently enabled for your organization. This feature allows
            you to track and manage shipment documents, items, and containers in one place.
          </p>

          <Button onClick={handleRequestAccess} disabled={requesting} size="lg" className="w-full">
            {requesting ? (
              <>
                <Loader2 className="animate-spin mr-2" size={20} />
                Requesting Access...
              </>
            ) : (
              'Request Access'
            )}
          </Button>

          <p className="text-sm text-gray-500 mt-4">
            Our team will review your request and contact you within 24 hours.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}

export default RequestAccess
